import { withInstall } from '@lit-element/utils'
import DatePicker from './src/date-picker'

import type { SFCWithInstall } from '@lit-element/utils'

export const LtDatePicker: SFCWithInstall<typeof DatePicker> =
  withInstall(DatePicker)

export default LtDatePicker
export * from './src/constants'
export * from './src/props/date-picker'
export type { DatePickerInstance } from './src/instance'
